cv.ProfileCropperView = Marionette.LayoutView.extend({
  id: 'modal-profile-cropper',

  getTemplate: function(){
    return cv.Templates['global/form/profileCropper'];
  },

  events : {
    'click .modal-confirm' : 'confirm',
    'click .modal-deny' : 'deny',
    'change .profile-cropper-file' : 'selectImage'
  },

  validation: {},

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('ProfileCropperView initialized');
  },

  templateHelpers: function(){
    return {
      confirm : 'Done',
      deny : 'Cancel'
    };
  },

  onAttach: function(){
  },

  selectImage: function(e){
    this.loading(true);

    var $img = this.$('.profile-cropper-image');
    var $uploadBox = this.$('.profile-cropper-dropzone');
    var profileCropperView = this;

    if (e.target.files && e.target.files[0]) {
      // init the file reader if files are set
      var reader = new FileReader();

      if ($img.hasClass('cropper-hidden')) {
        // destroy the cropper if it exists so we can change the image
        profileCropperView.cropper.destroy();
      }

      // set up the filereader onload and use it for cropper to edit the image on the client side
      reader.onload = function (e) {
        // set the image src to the selected file
        $img.attr('src', e.target.result);
        $uploadBox.removeClass('empty').addClass('filled');
        // show the image so cropper can use it
        $img.show();

        // init cropper
        profileCropperView.cropper = new Cropper($img[0], {
          zoomable: false,
          zoomOnWheel: false,
          zoomOnTouch: false,
          viewMode: 1,
          autoCropArea: 1,
          aspectRatio: 1/1,
          initialAspectRatio: 1/1,
          ready: function(event) {
            profileCropperView.loading(false);
          }
        });
      }

      // render/init
      reader.readAsDataURL(e.target.files[0]);

    }
  },

  uploadImage: function() {
    this.loading(true);

    var cropper = this.cropper;
    var formData = new FormData();
    var img;
    var key = this.options.key;
    var model = this.options.model;
    var options = this.options;
    var profileCropperView = this;
    var tmp = {};
    var upload_errors = 0;

    // Check if cropper has been initiated by fileupload
    if (typeof cropper !== "undefined") {
      img = cv.base64ToBlob(cropper.getCroppedCanvas().toDataURL('image/jpeg'));
    } else {
      vent.trigger('notif:error', 'No file was selected.');
      upload_errors++;
    }

    // Generate the policy
    $.ajax({
      url: cv.api_path + '/editor/generate_policy',
      type: 'POST',
      data : {
        file_extension : 'jpg'
      },
      dataType: 'json',
      async: false,
      beforeSend: function(jqXHR){
        jqXHR.setRequestHeader('Apikey', cv.PRELOADED.api_key);
      },
      success: _.bind(function(response) {
        var s3_policy = {
          key : response.key,
          AWSAccessKeyId : response.access_key,
          policy : response.policy,
          signature : response.signature,
          acl : 'public-read',
          success_action_status : '201',
          'X-Requested-With' : 'xhr',
          'Content-Type' : 'jpg'
        };

        for ( var key in s3_policy ) {
          formData.append(key, s3_policy[key]);
        }
      }, this),
      error: _.bind(function(result, textStatus, jqXHR) {
        vent.trigger('notif:error', 'There was an error generating the S3 policy.');
        return false;
      }, this)
    });

    // Create File from cropped image to pass to server (use Blob b/c if IE Edge issue)
    var imageFile = new Blob([img], {type : 'image/jpeg'});

    // Add the file to formData for ajax
    formData.append('file', imageFile);

    // Check the image size and throw an error if it's too big
    if(imageFile['size'] == '' || imageFile['size'] > 5000000) {
      vent.trigger('notif:error', 'That file is too large.  Please upload a file under 5 MB.');
      upload_errors++;
    }

    if(upload_errors === 0){
      // Send the image to S3
      $.ajax('//causevox-production.s3.amazonaws.com', {
        method: "post",
        data: formData,
        beforeSend: function(jqXHR){
        },
        processData: false,
        contentType: false,
        success: function (result, textStatus, jqXHR) {
          var s3_key = '/' + $(jqXHR.responseXML).find('Key').text();
          var s3_url = $(jqXHR.responseXML).find('Location').text();

          tmp[key] = s3_key;
          model.set(tmp);
          options.view.trigger('form:refresh_photo', key);
          vent.trigger('modal:hide');
        },
        error: function (xhr, status, error) {
          console.log('Upload error');
          vent.trigger('notif:error', 'There was a problem uploading the image, please try again later.');
        },
        fail: function (xhr, status, error) {
          console.log('Upload failed');
          vent.trigger('notif:error', 'There was a problem uploading the image, please try again later.');
        },
        complete: function() {
          profileCropperView.loading(false);
        }
      });
    }else{
      profileCropperView.loading(false);
    }
  },

  loading: function(isLoading) {
    var $message = this.$('.profile-cropper-message');
    var $buttons = this.$('.button');
    var $dropzone = this.$('.profile-cropper-dropzone');

    if (isLoading===true) {
      $dropzone.css({height:0, 'border-width': 0});
      $buttons.hide();
      $message.html('<div class="fileupload-loading"></div>').show();
    } else {
      $dropzone.css({height:150, 'border-width': 4});
      $buttons.show();
      $message.html('').hide();
    }
  },

  confirm: function(e){
    e.preventDefault();

    this.uploadImage()
  },

  deny: function(e){
    e.preventDefault();

    vent.trigger('modal:hide');
  }
});




